var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Information(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 9.12a28.88 28.88 0 10-.02 57.76A28.88 28.88 0 0038 9.12zm0 54A25.15 25.15 0 1163.15 38 25.18 25.18 0 0138 63.15v-.03zM40 49h7v4H29v-4h7V37h-6v-4h10v16zm-6.5-24.16a4 4 0 118 0 4 4 0 01-8 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Information.2a8613ef.svg";
export { SvgK1Information as ReactComponent };